import { useEffect, useRef, useState } from "react";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import ServiceTypeDetails from "../servicetypedetails/ServiceTypeDetails";
import { setServiceTypeData } from "../../RegistraionAction";
import {
  mobileNoRegex,
  phoneNoRegex,
  serviceNameRegex,
} from "../../../commoncomponents/input/Regex";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useNavigationType } from "react-router-dom";

let registerServiceType: any;

export let serviceTypeDetailobject = {
  serviceId: 0,
  clinicName: "",
  serviceType: "",
  numberAndRoad: "",
  district: "",
  serviceDistrict: "",
  townCity: "",
  countyText: "",
  postCode: "",
  country: "",
  phoneNumber: "",
  mobile: "",
  email: "",
  sameAsOrganization: false,
};

const ServiceTypeComponent = () => {
  let history = useNavigate();
  const location = useLocation();
  let navType = useNavigationType();
  const [mode, setMode] = useState("");
  const [headerButton, setHeaderButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useRef<any>();
  let clinicNamesList: { [key: number]: string } = {};
  const dispatch = useDispatch();
  const { organizationJson } = useSelector((state: any) => state.organization);
  const { serviceJson } = useSelector((state: any) => state.service);

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  useEffect(() => {
    isMounted.current = true;
    if (location?.state?.mode !== undefined) {
      setMode(location.state.mode);
      setHeaderButton(true);
    } else {
      setHeaderButton(false);
    }
    return () => {
      isMounted.current = false;
      setMode("");
    };
  }, [location]);

  useEffect(() => {
    isMounted.current = true;
    if (location?.state?.mode !== "edit") {
      if (
        organizationJson === undefined ||
        organizationJson === "" ||
        organizationJson === null
      ) {
        history("/organization");
      }
    }
    return () => {
      isMounted.current = false;
    };
  }, [location, organizationJson, history]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  const alertUser = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const getServiceData = async (serviceTypeDetailobject: any) => {
    let finalServiceTypeDetailobject = {
      serviceDetails: serviceTypeDetailobject,
    };

    setIsLoading(true);
    if (mode !== "edit" && organizationJson !== undefined) {
      registerServiceType = {
        ...organizationJson,
        ...finalServiceTypeDetailobject,
      };
      dispatch(setServiceTypeData(registerServiceType));
      history("/userservice");
      setIsLoading(false);
    }
  };

  let serviceDetails = {
    clinicName: Yup.string(),
    serviceType: Yup.string().required("Please select Service Type "),
    numberAndRoad: Yup.string().required("Please enter number & road."),
    serviceDistrict: Yup.string().required("Please enter district."),
    email: Yup.string()
      .email("Please enter valid email. ")
      .required("Please enter valid email."),
    mobile: Yup.string().matches(
      mobileNoRegex,
      "Please enter valid mobile number"
    ),
    phoneNumber: Yup.string()
      .nullable()
      .matches(phoneNoRegex, "Please enter valid phone number"),
    country: Yup.string().required(" Please select country"),
  };

  const formik = useFormik({
    initialValues: serviceTypeDetailobject,

    validationSchema: Yup.object(
      mode === "edit"
        ? serviceDetails
        : {
            clinicName: Yup.string()
              .max(30, "Name must be under 30 characters.")
              .default("")
              .required("This must not be empty.")
              .matches(serviceNameRegex, "Please enter valid clinic name.")
              .test(
                "unique",
                "Cannot have two clinic with similar name, Please enter unique clinic name",
                async (value: any, context: any) => {
                  for (let key in clinicNamesList) {
                    let serviceContextPath = "serviceName";
                    if (serviceContextPath === context.path.toString()) {
                      continue;
                    }
                    if (
                      value !== "" &&
                      clinicNamesList[key] !== "" &&
                      value === clinicNamesList[key]
                    ) {
                      return false;
                    }
                  }
                  return true;
                }
              ),
            serviceType: Yup.string().required("Please select Service Type "),
            numberAndRoad: Yup.string().required("Please enter number & road."),
            serviceDistrict: Yup.string().required("Please enter district."),
            email: Yup.string()
              .email("Please enter valid email. ")
              .required("Please enter valid email."),
            mobile: Yup.string().matches(
              mobileNoRegex,
              "Please enter valid mobile number"
            ),
            phoneNumber: Yup.string()
              .nullable()
              .matches(phoneNoRegex, "Please enter valid phone number"),
            country: Yup.string().required(" Please select country"),
          }
    ),
    onSubmit: async () => {},
  });
  return (
    <CommonLayout
      showHeaderNavigation={headerButton}
      isLogedIn={headerButton === false ? false : true}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          {mode !== "edit" && (
            <>
              <Typography variant="h1" className={globalClasses.pageTitle}>
                Register your Organization
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "10px",
                  color: "#474747",
                  fontSize: "14px",
                }}
              >
                Step 1 to step 4 is mandatory in order to complete registration
              </Typography>
            </>
          )}
        </Grid>
      </Grid>

      <ServiceTypeDetails
        mode={mode}
        organizationAddress={
          organizationJson !== undefined &&
          organizationJson !== null &&
          organizationJson !== ""
            ? organizationJson
            : ""
        }
        formik={formik}
        sendServiceData={getServiceData}
        clinicData={serviceJson}
      />

      {isLoading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Adding Service Types...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
    </CommonLayout>
  );
};

export default ServiceTypeComponent;
